import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { Resources } from '../components/Resources';
import { FAQ } from '../components/FAQ';
export function ResourcesPage() {
  return <main className="bg-white" data-id="element-567">
      <PageBanner title="Resources & Forms" subtitle="Download forms, find authorization numbers, and access helpful resources for your fingerprinting needs" data-id="element-568" />
      <Resources data-id="element-569" />
      <FAQ data-id="element-570" />
    </main>;
}